import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Filter, FilterId} from './extensions-gallery'
import {ExtensionStore} from './extensions-store'
import {ExtensionDetailsSidebar} from './screens/details/details-sidebar'
import {ExtensionsListSidebar} from './screens/list/list-sidebar'

const TwSidebar = tw.aside`
  h-full
  w-[248px]

  shadow-border-r-1
  shadow-grey-l60
`

const TwSidebarList = tw.div`
  h-full
`

type TwSidebarProps = {
  $isDisabled?: boolean
}

const TwExtensionDetails = tw.div<TwSidebarProps>`
  h-full
  ${p => (p.$isDisabled ? 'opacity-20 pointer-events-none' : '')}
`

type ExtensionsGallerySidebarProps = {
  openedDetails: ExtensionStore
  onResetSearch: () => void
  onSearchChanged: (text: string) => void
  onFilterChanged: (id: FilterId) => void
  onOpenSettings: (ext: ExtensionStore) => void
  isSearchActive: boolean
  isSidebarDisabled: boolean
  searchQuery: string
  filters: Filter[]
  activeFilter: Filter
  containerRef?: React.Ref<HTMLElement>
}

export const ExtensionGallerySidebar = observer(
  (props: ExtensionsGallerySidebarProps) => {
    const {
      openedDetails,
      isSearchActive,
      isSidebarDisabled,
      onResetSearch,
      onSearchChanged,
      onFilterChanged,
      onOpenSettings,
      filters,
      activeFilter,
      searchQuery,
      containerRef
    } = props

    let component = null

    if (openedDetails) {
      component = (
        <TwExtensionDetails $isDisabled={isSidebarDisabled}>
          <ExtensionDetailsSidebar
            containerRef={containerRef}
            extension={openedDetails}
            onOpenSettings={onOpenSettings}
          />
        </TwExtensionDetails>
      )
    } else {
      component = (
        <TwSidebarList>
          <ExtensionsListSidebar
            isSearchActive={isSearchActive}
            isSidebarDisabled={isSidebarDisabled}
            onResetSearch={onResetSearch}
            onSearchChanged={onSearchChanged}
            onFilterChanged={onFilterChanged}
            filters={filters}
            activeFilter={activeFilter}
            searchQuery={searchQuery}
          />
        </TwSidebarList>
      )
    }

    return <TwSidebar style={{width: '248px'}}>{component}</TwSidebar>
  }
)
